import { useMainNavigationStore } from '@centric-os/stores/navigation/use-main-navigation-store';
import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { FeatureFlags } from '@centric-os/types';
import { SitesRouteNames } from '@centric-os/sites/src/enums';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const beforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const navStore = useMainNavigationStore();
  const splitIoStore = useSplitIoStore();

  try {
    const isEnabled = splitIoStore.isFeatureOn(FeatureFlags.VOUCHERIFY_REPLACEMENT);

    if (isEnabled && navStore.canAccessLoyalty) {
      next();
    } else {
      next({ name: SitesRouteNames.SITES_LIST, replace: true });
    }
  } catch (error) {
    console.error('Error during navigation guard execution:', error);
    next(false);
  }
};
